import { render, staticRenderFns } from "./verResidente.vue?vue&type=template&id=7ba77ea1&scoped=true"
import script from "./verResidente.vue?vue&type=script&lang=js"
export * from "./verResidente.vue?vue&type=script&lang=js"
import style0 from "./verResidente.vue?vue&type=style&index=0&id=7ba77ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba77ea1",
  null
  
)

export default component.exports